import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { CookieComponent } from './cookie/cookie.component';
import { DietaChetogenicaComponent } from './dieta-chetogenica/dieta-chetogenica.component';
import { ProtocolloChetogenicoComponent } from './protocollo-chetogenico/protocollo-chetogenico.component';
import { ChiSonoComponent } from './chi-sono/chi-sono.component';
import { PartnerComponent } from './partner/partner.component';

const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: 'cookie', component: CookieComponent },
  { path: 'dieta-chetogenica', component: DietaChetogenicaComponent },
  { path: 'protocollo-chetogenico', component: ProtocolloChetogenicoComponent },
  { path: 'chi-sono', component: ChiSonoComponent },
  { path: 'partner', component: PartnerComponent },

  { path: "blog", loadChildren: () => import("./blog/blog.module").then(m => m.BlogModule) },
  { path: 'approfondimenti', loadChildren: () => import('./approfondimenti/approfondimenti.module').then(m => m.ApprofondimentiModule) },
  { path: 'in-evidenza', loadChildren: () => import('./in-evidenza/in-evidenza.module').then(m => m.InEvidenzaModule) },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })
],

exports: [RouterModule]

})

export class AppRoutingModule { }
